import { render, staticRenderFns } from "./Signers.vue?vue&type=template&id=3d1c4f66&scoped=true"
import script from "./Signers.vue?vue&type=script&lang=js"
export * from "./Signers.vue?vue&type=script&lang=js"
import style0 from "./Signers.vue?vue&type=style&index=0&id=3d1c4f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1c4f66",
  null
  
)

export default component.exports